import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Dashboard from "../src/components/Dashboard";
import NotFound from "../src/pages/NotFound";
import LandingPage from "../src/pages/LandingPage";
import Site from "../src/pages/Site";
import ProtectedRoute from "../src/components/ProtectedRoute";
import axios from "axios";
import { ThemeProvider } from "../src/context/ThemeContext"; // Import the ThemeProvider
import Login from "../src/pages/Login";
import Register from "../src/pages/Register";
import ForgotPassword from "../src/pages/ForgotPassword";
import PaymentPage from "../src/pages/Site/PaymentPage";
import SitePages from "../src/pages/Site/SitePages";
import SitePageContent from "../src/components/SitePageContent";
import SiteNavbar from "../src/components/SiteNavbar";
import config from "../src/config";
import RegistrationSuccess from "../src/pages/RegistrationSuccess";
import PricingPage from "../src/pages/Site/PricingPage";
import ContactUsPage from "../src/pages/Site/ContactUsPage";
import TextDataPage from "../src/pages/Site/TextDataPage";
import EmailVerifiedSuccess from "../src/pages/EmailVerifiedSuccess";
import EmailVerificationFailed from "../src/pages/EmailVerificationFailed";
import ResetPassword from "../src/pages/ResetPassword";
import SuccessPage from "../src/pages/SuccessPage";
import Home from "../src/pages/Home";
import ShopDashboard from "../src/components/shop/ShopDashboard";
import ShopLogin from "../src/components/shop/ShopLogin";
import ShopWishlist from "../src/pages/shop/ShopWishlist";
import ShopRegister from "../src/components/shop/ShopRegister";
import ShopForgotPassword from "../src/components/shop/ShopForgotPassword";
//shop
import { CartProvider } from "./context/CartContext";
import ShopNavbar from "../src/components/shop/ShopNavbar";
import ShopHome from "../src/pages/ShopHome"; // main shop landing page
import CheckoutPage from "../src/pages/shop/CheckoutPage";
import ShopProductPage from "../src/pages/shop/ShopProductPage";
import ShopCategoryPage from "../src/pages/shop/ShopCategoryPage";
import ShopPagesBar from "../src/components/shop/ShopPagesBar";
// import ShopCategoryPage from "../src/pages/ShopCategoryPage";
// import ShopProductPage from "../src/pages/ShopProductPage";
// import ShopWishlist from "../src/pages/ShopWishlist";
// import ShopCart from "../src/pages/ShopCart";
// import ShopCheckout from "../src/pages/ShopCheckout";

const baseUrl = config.baseURL;
// Setup Axios Interceptor (only in the browser)
const setupAxiosInterceptor = () => {
  if (typeof window !== "undefined") {
    // Ensure it's running in the browser
    axios.interceptors.response.use(null, (err) => {
      const token = localStorage.getItem("token");
      if (err.response.status === 401 && token) {
        localStorage.removeItem("token");
        alert("You are logged out, please login again");
        window.location.replace("/"); // This works only in the browser
      }
    });
  }
};

function App() {
  const [isClient, setIsClient] = useState(false);
  const [pages, setPages] = useState([]); // To store the pages data

  useEffect(() => {
    const fetchPages = async () => {
      try {
        const response = await fetch(`${baseUrl}/api/page`);
        if (!response.ok) {
          throw new Error("Error fetching pages");
        }
        const data = await response.json();
        setPages(data.data); // Adjust this if the response structure is different
      } catch (error) {
        console.error("Error fetching pages:", error.message);
      }
    };

    fetchPages();
  }, []);
  // Set the state to true once the component is mounted (client-side)
  useEffect(() => {
    setIsClient(true);
    setupAxiosInterceptor(); // Set up Axios interceptor in the client
  }, []);

  // Render loading state or server-side logic if necessary
  if (!isClient) {
    return <div>Loading...</div>; // Can be replaced with SSR-safe logic
  }
  // Function to check if Navbar should be shown
  // const getPageComponent = (type) => {
  //   switch (type) {
  //     case "career":
  //       return <CareerPage type="career" />;
  //     case "pricing":
  //       return <PricingPage type="pricing" />;
  //     case "textData":
  //       return <TextDataPage type="textData" />;
  //     case "contactUs":
  //       return <ContactUsPage type="contactUs" />;
  //     default:
  //       return <LandingPage />;
  //   }
  // };
  return (
    <ThemeProvider>
      <Router>
        {/* {showNavbar && <SiteNavbar />} */}

        {/* Define routes */}
        <Routes>
          {/* <Route path="/*" element={<SitePages />} /> */}
          <Route path="/" element={<Site />} />
          <Route path="/Register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/Payment" element={<PaymentPage />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Shop Routes */}
          <Route
            path="/shop"
            element={
              <CartProvider>
                <>
                  <ShopPagesBar />
                  <ShopNavbar />
                </>
              </CartProvider>
            }
          >
            <Route index element={<ShopDashboard />} />
            <Route path="products" element={<ShopDashboard />} />
            <Route path="wishlist" element={<ShopWishlist />} />
            <Route path="customerlogin" element={<ShopLogin />} />
            <Route path="customerRegister" element={<ShopRegister />} />
            <Route path="forgot-password" element={<ShopForgotPassword />} />
            <Route path="checkout" element={<CheckoutPage />} />
            <Route path="ProductPage/:id" element={<ShopProductPage />} />
            <Route path="category/:id" element={<ShopCategoryPage />} />
          </Route>

          <Route
            path="/emailVerifiedSuccess"
            element={<EmailVerifiedSuccess />}
          />
          <Route
            path="/emailVerifiedFailed"
            element={<EmailVerificationFailed />}
          />
          <Route
            path="/RegistrationSuccess"
            element={<RegistrationSuccess />}
          />
          <Route path="/success" element={<SuccessPage />} />

          {/* {pages.map((page) => (
            <Route
              key={page.id}
              path={`/${page.type}`} // Use the `type` as the path
              element={getPageComponent(page.type)} // Render the corresponding component
            />
          ))} */}
          <Route
            path="/dashboard/*"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Home />} />

          {/* <Route path="/*" element={<Home />} /> */}
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
